function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import SelectableTagsGrid from "segments/desktop/core-components/selectable-tags-grid/selectable-tags-grid";
import classnames from "classnames";
import { StyledSelectableTagsGridComponent } from "./selectable-tags-grid-component.scss";
import DefaultProps from "./selectable-tags-grid-default-props";
const SelectableTagsGridComponent = (props)=>{
    const { websiteAlignmentBranding } = props;
    return /*#__PURE__*/ _jsx(StyledSelectableTagsGridComponent, {
        className: classnames("selectable-tags-grid-component", {
            "website-alignment-branding": websiteAlignmentBranding
        }),
        children: /*#__PURE__*/ _jsx(SelectableTagsGrid, _object_spread({}, props))
    });
};
SelectableTagsGridComponent.defaultProps = DefaultProps;
export default SelectableTagsGridComponent;
